enum ESearchType {
    SEARCH = "Search",
    IMAGES = "Images",
    VIDEOS = "Videos",
    NEWS = "News",
    MAPS = "Maps",
    SHOPPING = "Shopping",
    AI_MODE = "AiMode",
}

enum ESearchTypeId {
    SEARCH = "7",
    IMAGES = "103",
    VIDEOS = "109",
    NEWS = "108",
    MAPS = "107",
    SHOPPING = "110",
    AI_MODE = "111",
}

const searchTypes = [
    {
        id: ESearchTypeId.SEARCH,
        value: ESearchType.SEARCH,
        text: "Regular Search",
    },
    {
        id: ESearchTypeId.IMAGES,
        value: ESearchType.IMAGES,
        text: "Image Search",
    },
    {
        id: ESearchTypeId.SHOPPING,
        value: ESearchType.SHOPPING,
        text: "Shopping Search",
    },
    {
        id: ESearchTypeId.VIDEOS,
        value: ESearchType.VIDEOS,
        text: "Video Search",
    },
    {
        id: ESearchTypeId.MAPS,
        value: ESearchType.MAPS,
        text: "Maps Search",
    },
    {
        id: ESearchTypeId.NEWS,
        value: ESearchType.NEWS,
        text: "News Search",
    },
    {
        id: ESearchTypeId.AI_MODE,
        value: ESearchType.AI_MODE,
        text: "AI Mode",
    },
];

export default searchTypes;
